/* eslint-disable @typescript-eslint/no-var-requires */
export const { default: StatsICon } = require('./statistics-svgrepo-com.svg');
